import { Component, OnInit } from '@angular/core';
import {CoreComponent} from '../../core/core.component';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Results} from '../../core/results';
import {PlaceOfApplication} from './place-of-application/place-of-application';
import {PlacesOfApplicationService} from './places-of-application.service';
import {PlaceOfApplicationComponent} from './place-of-application/place-of-application.component';
import {HttpErrorResponse} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Meta, Title} from '@angular/platform-browser';
import {GoogleAnalyticsService} from 'ngx-google-analytics';
declare var bootbox: any;
@Component({
  selector: 'app-places-of-application',
  templateUrl: './places-of-application.component.html',
  styleUrls: ['./places-of-application.component.scss']
})
export class PlacesOfApplicationComponent extends CoreComponent<PlaceOfApplication> {
  @BlockUI() blockUI: NgBlockUI;
  constructor(protected servicesService: PlacesOfApplicationService, public route: ActivatedRoute,private matSnackBar: MatSnackBar,
              public activeModal: NgbActiveModal,protected gaService: GoogleAnalyticsService,
              private modalService: NgbModal, private router: Router,public meta: Meta, public title: Title) {
    super(servicesService,route);
    this.title.setTitle('Places Of Application');

  }

  public search() {
    this.blockUI.start();
    this.servicesService.search(this.currentPage, this.perPage, this.order, this.orderBy, this.keyword)
      .subscribe((data: Results<PlaceOfApplication>) => {
        this.results = data;
        this.blockUI.stop();
      },(error: HttpErrorResponse) => {
        this.blockUI.stop();
        this.gaService.exception(error.error?.message, true);
        if (error.status === 401) {
          this.activeModal.close();
          this.router.navigate(['/']);
          this.matSnackBar.open('Your session has expired', 'Okay', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        }else {
          this.blockUI.stop();
          this.matSnackBar.open(error.error.message, 'Okay', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        }
      });
  }

  remove(item: PlaceOfApplication){
    const that = this;
    bootbox.confirm({
      title: 'Are you sure you want to delete?',
      message: '<strong>'+item.name+'</strong>',
      callback: function(result) {
        if (result === null) {
        } else if (result === true) {

          that.servicesService.delete(item.id).subscribe(()=>{
            that.search();
          },(error: HttpErrorResponse) => {
            this.blockUI.stop();
            this.gaService.exception(error.error?.message, true);
            if (error.status === 401) {
              this.activeModal.close();
              this.router.navigate(['/']);
              this.matSnackBar.open('Your session has expired', 'Okay', {
                duration: 5000,
                horizontalPosition: 'center',
                verticalPosition: 'top',
              });
            }else {
              this.blockUI.stop();
              this.matSnackBar.open(error.error.message, 'Okay', {
                duration: 5000,
                horizontalPosition: 'center',
                verticalPosition: 'top',
              });
            }
          });
        }
      }
    });
  }

  newItem() {
    this.item = new PlaceOfApplication();
    this.open(this.item);
  }
  open(item: PlaceOfApplication) {
    const modalRef = this.modalService.open(PlaceOfApplicationComponent, {fullscreen:true, modalDialogClass:'animate-bottom'});
    modalRef.componentInstance.item= item;
    modalRef.componentInstance.name = 'World';
    modalRef.closed.subscribe(()=>{
      this.search();
    });
  }


}
